import { ReactNode, FormEvent } from 'react';
import { useFormikContext } from 'formik';

import { useNoteFormContext } from '../context/noteFormContext';
import { NoteFormValues } from '../utils/validation';

type FormProps = {
  children: ReactNode;
  id?: string;
};

export const Form = ({ children, id = 'noteEdit' }: FormProps) => {
  const formik = useFormikContext<NoteFormValues>();
  const {
    actions: { resetNote }
  } = useNoteFormContext();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await formik.handleSubmit();
  };

  const handleReset = () => {
    resetNote();
  };

  return (
    <form onSubmit={handleSubmit} onReset={handleReset} id={id}>
      {children}
    </form>
  );
};
